import { Component, OnInit } from '@angular/core';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';

//models
import { newConnectionLoginModel } from '../../models/newConnectionLogin/newConnectionLogin.model';
import * as CryptoJS from 'crypto-js';
import { AppSettings } from '../../config/settings/app-settings';
import { Router } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './newConnectionLogin.component.html'
})
export class NewConnectionLoginComponent implements OnInit {

  //variable deceleration
  private errorMsg : string = "";
  private successMsg : string = "";
  private sessionData : any;
  public newConnectionLoginModel: newConnectionLoginModel = new newConnectionLoginModel;
  private allUserData : any = [];
  private loggedInUserData :any = "";
  private viewpopupopen : boolean = false;
  private authUser : boolean = false;
  private otpSend : boolean = false;
  private sendOtpResponeData : any = "";
  private validateOtpResponeData : any = "";
  
  constructor(private http: HttpTestService, private session: sessionServices,private router : Router) { }

  ngOnInit() {
	  this.getSession();
  }
  
  
  //get session details
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
	}
	
	
	transactionLogin = function(){
    this.router.navigateByUrl('/consumerBasicInfo',{ skipLocationChange: true });
    
    }
	
  
 
 resetForm = function(){
	 var self = this;
	 self.loginmodel.SignInEmail = "";
   self.loginmodel.SignInPass = "";
	 self.loginmodel.consumerOtp = "";
	 self.otpSend = false;
 }
  

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/newConnectionLogin/newConnectionLogin.component.ts